import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { IonApp } from '@ionic/vue'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_metainfo = _resolveComponent("metainfo")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_unref(IonApp), null, {
    default: _withCtx(() => [
      _createVNode(_component_metainfo, null, {
        title: _withCtx(({ content }) => [
          _createTextVNode(_toDisplayString('비즈플랫-구구톡 | ' + content), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_router_view)
    ]),
    _: 1
  }))
}
}

})